module.exports = __webpack_public_path__ + "static/template_options_agenda-0f6c27405ff2d683dc170526782c3f97.png";